var AppComponent = (function () {
    function AppComponent() {
        this.title = 'app';
    }
    return AppComponent;
}());
export { AppComponent };



// WEBPACK FOOTER //
// /build/client-cms/src/app/app.component.ts.pre-build-optimizer.js